import {useEffect, useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {Modal} from 'react-bootstrap';
import bg1 from '../../../images/newDesign/coub5.svg';
import bg2 from '../../../images/newDesign/coub6.svg';
import user from '../../../images/newDesign/user.svg';
import close from '../../../images/newDesign/close.svg';
import { constants } from '../../../common/constants/constants';
import {StyledModal} from '../../../common/shared/modal.styled';

const StyledDetailsModal = styled(StyledModal)`
  .report-modal {
    position: relative;
    max-width: 660px;
    width: 100%;
  }

  .bg, .bg-small {
    position: absolute;
    z-index: 0;
  }
  .bg {
    left: 60px;
    top: -50px;
  }
  .bg-small {
    right: 100px;
    top: -50px;
  }
  
  .modal-header {
    z-index: 1;
    padding: 14px;
    color: #fff;
    background: linear-gradient(90deg, #6895FF 1.74%, #8C5CFF 100.15%);
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
  }
  .modal-title {
    font-size: 22px;
    line-height: 1;
  }
  .modal-body {
    min-height: 320px;
  }
  .modal-dialog .modal-close {
    top: 14px;
    left: 25px;
  }
  .content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .image {
    width: 45px;
    height: 45px;
    margin-bottom: 30px;
    img {
      width: 100%;
      height: auto;
    }
  }
  h3 {
    font-size: 30px;
    margin-bottom: 25px;
  }
  .data {
    font-size: 25px;
    text-align: center;
    p:last-child {
      margin-bottom: 0;
    }
    span {
      display: inline-block;
    }
    .phone {
      color: ${props => props.theme.main};
      font-weight: bold;
    }
    .type {
      position: relative;
      padding-left: 32px;
      &::after {
        position: absolute;
        content: '';
        top: 7px;
        left: 15px;
        width: 2px;
        height: 27px;
        background: ${props => props.theme.main};
      }
    }
    .separator {
      margin: 0 4px;
    }
    a {
      font-size: 22px;
      color: ${props => props.theme.main};
    }
  }
`;

export default function TenantDetailsModal({show, onHide, apartmentNumber, buildingId}) {
    const {t} = useTranslation();
    const managerData = useSelector(state => state.buildings.managerData);
    const [apartmentData, setApartmentData] = useState({});

    useEffect(() => {
        if (managerData.tenants) {
            setApartmentData(managerData.tenants[apartmentNumber]?.tenantListData);
        }
    }, [managerData, apartmentNumber]);

    return (
        <StyledDetailsModal
            dialogClassName={'report-modal'}
            show={show}
            onHide={onHide}
            centered
        >
            <div
                className={'modal-close'}
                onClick={onHide}
            >
                <img src={close} alt="close" />
            </div>
            <Modal.Header>
                <Modal.Title>{t('reports.apartment.tenantDetails')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={'bg'}>
                    <img src={bg1} alt="bg"/>
                </div>
                <div className={'bg-small'}>
                    <img src={bg2} alt="bg small"/>
                </div>
                <div className={'content'}>
                    <div className={'image'}>
                        <img src={user} alt="tenant details"/>
                    </div>
                    <h3>{`${t('reports.apt')} ${apartmentNumber}`}</h3>
                    <div className={'data'}>
                        {apartmentData?.OwnerName && (
                            <p>
                                <span className={'type'}>{t('payments.owner')}</span>
                                <span>{apartmentData?.OwnerName}</span>
                                <span className={'separator'}>:</span>
                                <span className={'phone'}>{apartmentData?.OwnerPhone}</span>
                            </p>
                        )}
                        {
                            apartmentData?.RenterName && (
                                <p>
                                    <span className={'type'}>{t('payments.renter')}</span>
                                    <span>{apartmentData?.RenterName}</span>
                                    <span className={'separator'}>:</span>
                                    <span className={'phone'}>{apartmentData?.RenterPhone}</span>
                                </p>
                            )
                        }
                        {!(apartmentData?.OwnerName && apartmentData?.RenterName) && (
                            <Link
                                to={`/${constants.pages.tenantListUrl}/${buildingId}`}>{t('reports.apartment.tenantsPage')}</Link>
                        )}
                    </div>
                </div>
            </Modal.Body>
        </StyledDetailsModal>
    );
}
